import CustomButton from "../../../components/CustomButton";
import CustomInput from "../../../components/CustomInput";
import SubHeadings from "../../../components/SubHeadings";
import { plus, trash } from "../../../asset";
import { useFormEdit } from "../../../util/hooks/useFormEdit";
import { useEffect, useState } from "react";
import MedicalFields from "../../../components/modal/MedicalFields";
import { Student } from "../../../types/studentType";

interface madicalInformationProps {
  form: ReturnType<typeof useFormEdit<Student>>;
}

export default function MedicalDetalisSection({
  form,
}: madicalInformationProps) {
  const { formData, setFormData, isEditing } = form;

  const handleInputChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value, type } = event.target;

    let newValue: any = value;

    if (type === "radio" && name === "vaccinationsUpToDate") {
      if (value === "true") newValue = true;
      else if (value === "false") newValue = false;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  return (
    <div className="px-4 md:px-9 flex flex-col md:flex-row gap-9">
      <div className="flex flex-col gap-7 w-full py-7">
        <div className="flex flex-col md:flex-row gap-4 md:justify-between md:items-center">
          <SubHeadings text="Medical Details" />
          {/* <div className="flex justify-end items-end">
            <CustomButton
              text="Add Field"
              color="bg-success-600"
              icon={plus}
              disabled={!isEditing}
              onClick={() => setShowModal(true)}
            />
            {showModal && (
              <MedicalFields
                onClose={() => setShowModal(false)}
                onSave={handleAddCustomField}
              />
            )}
          </div> */}
        </div>
        <form className="grid gap-7">
          <div className="grid lg:flex gap-7 ">
            <CustomInput
              name="bloodGroup"
              label="Blood Group"
              readOnly={!isEditing}
              type="text"
              placeholder="Ex: O+"
              value={formData.bloodGroup ?? ""}
              onChange={handleInputChange}
              inputClassName="w-full"
              className="lg:w-[50%]"
            />

            <CustomInput
              name="allergies"
              label="Allergies (if any)"
              type="text"
              readOnly={!isEditing}
              placeholder="Please mention Allergies (if any)"
              value={formData.allergies ?? ""}
              onChange={handleInputChange}
              inputClassName="w-full"
              className="lg:w-full"
            />
          </div>

          <div className="grid gap-7">
            <CustomInput
              name="existingMedicalConditions"
              label="Any existing medical conditions?"
              readOnly={!isEditing}
              type="text"
              placeholder="If yes, then please mention the medical conditions properly."
              value={formData.existingMedicalConditions ?? ""}
              onChange={handleInputChange}
              inputClassName="w-full"
            />

            <CustomInput
              name="medications"
              label="Medications (if any)"
              type="text"
              readOnly={!isEditing}
              placeholder="Is the child on any medications"
              value={formData.medications ?? ""}
              onChange={handleInputChange}
              inputClassName="w-full"
            />
          </div>

          <div className="flex flex-col md:flex-row gap-7  md:items-center text-nowrap">
            <label className="text-sm font-semibold text-neutral-400 block">
              Vaccinations are up to date?
            </label>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <CustomInput
                  name="vaccinationsUpToDate"
                  type="radio"
                  checked={formData.vaccinationsUpToDate === true}
                  value="true"
                  onChange={handleInputChange}
                  disabled={!isEditing}
                  inputClassName="w-3 h-3"
                />
                <span
                  className={`text-sm font-semibold ${
                    formData.vaccinationsUpToDate === true
                      ? "text-primary-500"
                      : "text-neutral-300"
                  }`}
                >
                  Yes
                </span>
              </div>

              <div className="flex items-center gap-2">
                <CustomInput
                  name="vaccinationsUpToDate"
                  type="radio"
                  checked={formData.vaccinationsUpToDate === false}
                  value="false"
                  onChange={handleInputChange}
                  disabled={!isEditing}
                  inputClassName="w-3 h-3"
                />
                <span
                  className={`text-sm font-semibold ${
                    formData.vaccinationsUpToDate === false
                      ? "text-primary-500"
                      : "text-neutral-300"
                  }`}
                >
                  No
                </span>
              </div>

              <div className="flex items-center gap-2">
                <CustomInput
                  name="vaccinationsUpToDate"
                  type="radio"
                  checked={formData.vaccinationsUpToDate === "not sure"}
                  value="not sure"
                  onChange={handleInputChange}
                  disabled={!isEditing}
                  inputClassName="w-3 h-3"
                />
                <span
                  className={`text-sm font-semibold ${
                    formData.vaccinationsUpToDate === "not sure"
                      ? "text-primary-500"
                      : "text-neutral-300"
                  }`}
                >
                  Not Sure
                </span>
              </div>
            </div>
          </div>

          {/* <div className="grid lg:grid-cols-2 gap-4">
            {customFields.map((field, index) => (
              <div key={index} className="relative group">
                <CustomInput
                  name={field.name}
                  label={field.name}
                  placeholder={field.description}
                  readOnly={!isEditing}
                  value={formData[field.name] || ""}
                  onChange={handleInputChange}
                  inputClassName="w-full"
                />
                {isEditing && (
                  <img
                    src={trash}
                    alt="Delete"
                    className="absolute top-2 right-3 w-4 h-4 bg-error-50 rounded cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity duration-200 hover:bg-error-100"
                  />
                )}
              </div>
            ))}
          </div> */}

          {/* <div className="flex justify-end items-end relative group">
            <CustomButton
              color="bg-primary-500"
              text="Submit"
              disabled={!hasUnsavedChanges || !isEditing}
            />

            {!hasUnsavedChanges && (
              <span className="absolute bottom-full mb-2  bg-neutral-300 text-white text-xs font-medium px-3 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                {isEditing
                  ? "No changes yet — fill out or edit the form to get started"
                  : "Enable edit mode to make changes"}
              </span>
            )}
          </div> */}
        </form>
      </div>
    </div>
  );
}
